import {
	DISTRICT_ADMIN,
	GLOBAL_ADMIN,
	INSTRUCTOR,
	LITERACY_CHAMPION,
	LITERACY_OUTCOMES_SPECIALIST,
	SCHOOL_ADMIN
} from './roles';

const getRoleAsNumber = (role) => {
	switch(role) {
		case GLOBAL_ADMIN:
			return 6;
		case LITERACY_OUTCOMES_SPECIALIST:
			return 5;
		case DISTRICT_ADMIN:
			return 4;
		case SCHOOL_ADMIN:
			return 3;
		case LITERACY_CHAMPION:
			return 2;
		case INSTRUCTOR:
			return 1;
		default:
			throw new Error(`Invalid role: ${ role }`);
	}
};

const getCurrentTime = () => {
	return Math.floor(new Date().getTime() / 1000);
};

const hasRoleOfAtLeast = (role, user) => {
	if (user && user.role) {
		return getRoleAsNumber(user.role) >= getRoleAsNumber(role);
	} else {
		return false;
	}
};

const isInternalLOI = (userObj) => {
	const userEmail = userObj.email;
	const emailRegExp = /@learningovations.com$/;
	const emailWhiteList = [
		'jcrubicon@gmail.com'
	];

	return userEmail.match(emailRegExp) || emailWhiteList.includes(userEmail);
};

const isAtLeastGlobalAdmin = (user) => {
	return hasRoleOfAtLeast(GLOBAL_ADMIN, user);
};

const isAtLeastLOS = (user) => {
	return hasRoleOfAtLeast(LITERACY_OUTCOMES_SPECIALIST, user);
};

const isLOS = (user) => {
	return user.role === LITERACY_OUTCOMES_SPECIALIST;
};

const isGlobalAdmin = (user) => {
	return user.role === GLOBAL_ADMIN;
};

const isAtLeastDistrictAdmin = (user) => {
	return hasRoleOfAtLeast(DISTRICT_ADMIN, user);
};

const isAtLeastSchoolAdmin = (user) => {
	return hasRoleOfAtLeast(SCHOOL_ADMIN, user);
};

const isAtLeastLiteracyChampion = (user) => {
	return hasRoleOfAtLeast(LITERACY_CHAMPION, user);
};

export const authTools = {
	hasRoleOfAtLeast,
	isAtLeastDistrictAdmin,
	isAtLeastGlobalAdmin,
	isAtLeastLiteracyChampion,
	isAtLeastLOS,
	isAtLeastSchoolAdmin,
	isGlobalAdmin,
	isInternalLOI,
	isLOS,

	hydrateState: (thisLocalStorage) => {
		const baseAuth = { exp: 0 };
		const authJson = thisLocalStorage.getItem('auth');
		const sessionExpirationMessage = 'Your session has expired. Please login again.';

		let isAuthenticated = false,
			user = null,
			exp = 0,
			errorMessage = null,
			token = null,
			authItem = null;

		try {
			const currentTime = getCurrentTime();

			authItem = JSON.parse(authJson) ? JSON.parse(authJson) : baseAuth;

			if (currentTime > authItem.exp) {
				console.log('Session has timed out'); // eslint-disable-line no-console

				if (authJson) {
					thisLocalStorage.removeItem('auth');
					errorMessage = sessionExpirationMessage;
				}
			} else {
				isAuthenticated = true;
				user = authItem.user;
				exp = authItem.exp;
				token = authItem.token;

				return {
					isAuthenticated,
					user,
					exp,
					errorMessage,
					token
				};
			}
		} catch (e) {
			console.error(e); // eslint-disable-line no-console

			return {
				isAuthenticated,
				user,
				exp,
				errorMessage,
				token
			};
		}
	},

	// "Pure" here means we want to distinguish a user who is only a literacy coach from one who is a literacy coach AND a teacher.
	isPureCoach: (user) => {
		return user && user.literacy_coach_classroom_ids.length && !user.teacher_classroom_ids.length;
	},

	canEditActivities: (user) => {
		if (user) {
			return user.can_edit_activities || hasRoleOfAtLeast(LITERACY_OUTCOMES_SPECIALIST, user);
		} else {
			return false;
		}
	}
};



// WEBPACK FOOTER //
// ./frontend/shared/js/lib/authTools.js